export default __webpack_public_path__ + "static/media/travel_title.faf94433.svg";